import FetchAPI from 'api/FetchAPI';

/**
 * @param propertyId
 * @returns {Promise<string[]>}
 */
async function getUserPhotos(propertyId) {
  return FetchAPI.getJson(`/api/properties/${propertyId}/user/photos`);
}

const UserAssetsApi = {
  getUserPhotos,
};

export default UserAssetsApi;
